import React from 'react';
import PropTypes from 'prop-types';

/**
 * @param {string} children - the message to display
 * @param {string} type - the type of alert to display (success, info, warning, danger), it uses bootstrap alert classes
 */
const Alert = ({ type = 'info', children }) => {
	return (
		<div className={`alert-${type} alert`} role="alert">
			<i aria-hidden="true" className="ddc-icon ddc-icon-alert" />
			<div className="alert-content">
				<p>{children}</p>
			</div>
		</div>
	);
};

Alert.propTypes = {
	children: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired
};

export default Alert;
